import { useEffect, useState } from 'react';
import { Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../components';
import { request, toast } from '../../../../../utils';
import { LIMIT_TYPE } from '../../../../../constants';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const REFERRAL_HEADER = [
  {
    header: 'Test Name',
    accessor: 'test_name',
    sx: { textTransform: 'capitalize' }
  },

  {
    header: 'Min Qty',
    accessor: 'min_qty'
  },
  {
    header: 'OPD Charges',
    accessor: 'opd_charges'
  },
  {
    header: 'IPD Charges',
    accessor: 'ipd_charges'
  },
  {
    header: 'Share%',
    accessor: 'share'
  },
  {
    header: 'Share Amt.',
    accessor: 'share_amt'
  },
  {
    header: 'Self%',
    accessor: 'self'
  },
  {
    header: 'Self Amt.',
    accessor: 'self_amt'
  },

  {
    header: 'Action'
  }
];

export const ReferralShareSetup = () => {
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        discount_authority: Yup.string().required('Discount Authority Is Required ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('discount_authority', selectedRecord.discount_authority);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        discount_authority: formValues.discount_authority,
        limit_type: formValues.limit_type
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Discount Authority master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Discount Authority master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Discount Authority master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Discount Authority master', { variant: 'error' });
    }
    setLoading(false);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3">
                Refferal Share Setup
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button variant="contained">Apply</Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>

            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Ref. Name</Typography>
                  <SelectTag formControlSX={{ flex: 0.8 }} placeholder="Enter Ref Name" name="ref_name" />
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Sponsor Name</Typography>
                  <SelectTag formControlSX={{ flex: 0.8 }} name="sponsor_name" />
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Applied On</Typography>
                  <SelectTag formControlSX={{ flex: 0.3 }} name="applied_on" />
                  <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }} variant="contained">
                    <AddIcon />
                  </Button>
                  <TextField sx={{ flex: 0.2 }} name="applied_on" />
                  <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }} variant="contained">
                    <RemoveIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', minHeight: '30rem', flexDirection: 'column', gap: 0.3 }}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={serviceList}
                  columns={REFERRAL_HEADER}
                  size="medium"
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
